<template>
  <div>
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="download-contents">
        <div class="banner_img">
            <img :src="webUrl" alt="" srcset="">
        </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../component/Nav.vue";
export default {
  name:'helpDown',
  data() {
    return {
      webUrl:'',
    };
  },
  created() {
    // https://oss.ansongqiubo.com/assets/person/helps.png
    this.webUrl = this.$route.query.urls;
  },
  components: {
    Nav,
  },
};
</script>

<style lang='scss' scope>

.download-contents {
  display: flex;
  justify-content: center;
  background:linear-gradient(to bottom right,#f9f9f9,50%,#f3f3f3);
  .banner_img{
      border-radius:4px;
      max-width:85vh;
      min-width: 1200px;
      img{
          margin: 20px 0;
          max-width: 1200px;
          
      }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/template/innerWeb.vue